module.exports = __webpack_public_path__ + "593a3d53/img/menu-icon.5f8facae.svg";